import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { FaEnvelope } from 'react-icons/fa';
import axios from 'axios';

const EmailEmployeesModal = ({ show, handleClose, employees }) => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Format the recipients for display
  const recipientEmails = employees.map(emp => emp.Email).join(', ');
  const recipientNames = employees.map(emp => `${emp.FirstName} ${emp.LastName}`).join(', ');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!subject.trim()) {
      setError('Please enter a subject');
      return;
    }
    
    if (!message.trim()) {
      setError('Please enter a message');
      return;
    }
    
    setIsSending(true);
    setError(null);
    
    try {
      // Get the token from localStorage
      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('Authentication token not found. Please log in again.');
      }
      
      // Set up request config with auth header
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token
        }
      };
      
      // Send API request to send the email
      const response = await axios.post(
        '/api/email/send-employee-email', 
        {
          to: employees.map(emp => emp.Email),
          subject: subject,
          message: message,
          employeeIds: employees.map(emp => emp.EmployeeId)
        },
        config
      );

      console.log('Email API response:', response.data);
      
      if (response.data.success) {
        // Success
        setSuccess(true);
        setTimeout(() => {
          handleReset();
          handleClose();
        }, 2000);
      } else {
        throw new Error(response.data.msg || 'Failed to send email');
      }
    } catch (err) {
      console.error('Email error:', err);
      setError(err.response?.data?.msg || err.message || 'Failed to send email. Please try again.');
    } finally {
      setIsSending(false);
    }
  };

  const handleReset = () => {
    setSubject('');
    setMessage('');
    setError(null);
    setSuccess(false);
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <FaEnvelope className="me-2" />
          Email to Employees
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" onClose={() => setError(null)} dismissible>
            {error}
          </Alert>
        )}
        
        {success && (
          <Alert variant="success">
            Email sent successfully!
          </Alert>
        )}
        
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>To:</Form.Label>
            <Form.Control 
              type="text" 
              value={recipientEmails} 
              readOnly 
            />
            <Form.Text className="text-muted">
              Recipients: {recipientNames}
            </Form.Text>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Subject:</Form.Label>
            <Form.Control 
              type="text" 
              value={subject} 
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Enter email subject"
              required
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Message:</Form.Label>
            <Form.Control 
              as="textarea" 
              rows={6} 
              value={message} 
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter your message here"
              required
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isSending}>
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={handleSubmit} 
          disabled={isSending || success}
        >
          {isSending ? 'Sending...' : 'Send Email'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmailEmployeesModal;